import IndeterminateCircularProgress from './IndeterminateCircularProgress';

export default IndeterminateCircularProgress;
